/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RedeemXpMultiplierBody
 */
export interface RedeemXpMultiplierBody {
    /**
     * 
     * @type {string}
     * @memberof RedeemXpMultiplierBody
     */
    transactionHash?: string;
    /**
     * 
     * @type {string}
     * @memberof RedeemXpMultiplierBody
     */
    nftOwnershipId: string;
}

/**
 * Check if a given object implements the RedeemXpMultiplierBody interface.
 */
export function instanceOfRedeemXpMultiplierBody(value: object): value is RedeemXpMultiplierBody {
    if (!('nftOwnershipId' in value) || value['nftOwnershipId'] === undefined) return false;
    return true;
}

export function RedeemXpMultiplierBodyFromJSON(json: any): RedeemXpMultiplierBody {
    return RedeemXpMultiplierBodyFromJSONTyped(json, false);
}

export function RedeemXpMultiplierBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): RedeemXpMultiplierBody {
    if (json == null) {
        return json;
    }
    return {
        
        'transactionHash': json['transactionHash'] == null ? undefined : json['transactionHash'],
        'nftOwnershipId': json['nftOwnershipId'],
    };
}

export function RedeemXpMultiplierBodyToJSON(json: any): RedeemXpMultiplierBody {
    return RedeemXpMultiplierBodyToJSONTyped(json, false);
}

export function RedeemXpMultiplierBodyToJSONTyped(value?: RedeemXpMultiplierBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'transactionHash': value['transactionHash'],
        'nftOwnershipId': value['nftOwnershipId'],
    };
}

